import {
  Button,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Spin,
  Table,
  Tabs,
  Tag,
} from "antd";
import React, { useEffect, useState } from "react";
import { FaEdit, FaEye, FaPlus, FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import product_img from "../../assets/product_img.png";
import { useDispatch, useSelector } from "react-redux";
import { getAllStoresAsync } from "../../services/StoreManagementServices";
import { asyncStatus } from "../../utils/asyncStatus";

const { TabPane } = Tabs;
const { Option } = Select;

const StoreManagement = () => {
  const [search, setSearch] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { get_all_stores_data, get_all_stores_status } = useSelector(
    (state) => state.storeManagement
  );

  const storesLoader = get_all_stores_status === asyncStatus.LOADING;

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const columns = [
    {
      title: "Store Name",
      key: "name",
      render: (record) => (
        <Space>
          <img
            src={
              record?.logo ||
              "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
            }
            alt="logo"
            style={{
              width: 40,
              height: 40,
              borderRadius: "8px",
              objectFit: "contain",
            }}
          />
          <span>{record?.name}</span>
        </Space>
      ),
    },
    {
      title: "Contact Email",
      dataIndex: "contactEmail",
      key: "contactEmail",
    },
    {
      title: "Contact Phone",
      dataIndex: "contactPhones",
      key: "contactPhones",
      // render: (phones) => phones.join(", "),
      render: (phones) => (
        <Space>
          <span style={{ whiteSpace: "wrap" }}>{phones.join(", ")}</span>
        </Space>
      ),
    },
    // {
    //   title: "Open & Close Time",
    //   key: "closeTime",
    //   render: (record) => `${record?.openTime} - ${record?.closeTime}`,
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <Space>
          <Button
            onClick={() =>
              navigate(`/store-management/${record?._id}`)
            }
            icon={<FaEye />}
          />
          <Button
            onClick={() =>
              navigate("/store", {
                state: record?.vendor_id?._id,
              })
            }
            icon={<FaEdit />}
          />
          {/* <Button onClick={() => console.log(record?.vendor_id?._id)} icon={<FaEdit />} /> */}
        </Space>
      ),
    },
  ];

  const filteredStores = get_all_stores_data?.stores?.filter((store) =>
    store?.name?.toLowerCase()?.includes(search?.toLowerCase())
  );

  useEffect(() => {
    dispatch(getAllStoresAsync());
  }, []);

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-center mb-4">Store Management</h1>

      <div className="flex justify-between my-4">
        <Input
          placeholder="Search by name"
          prefix={<FaSearch />}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: "300px" }}
        />
        <Button
          type="primary"
          icon={<FaPlus />}
          onClick={() => navigate("/store")}
        >
          Add Store
        </Button>
      </div>
      {storesLoader ? (
        <div className="flex items-center justify-center h-[40vh]">
          <Spin size="large" className="flex justify-center" />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={filteredStores || []}
          pagination={{ pageSize: 15 }}
          rowKey="_id"
        />
      )}
      <Modal
        // title={editingUser ? "Edit User" : "Add User"}
        title={"Edit Store"}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          //   setEditingUser(null);
          //   form.resetFields();
        }}
        // onOk={handleAddOrUpdateUser}
        // confirmLoading={loading}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="role" label="Role">
            <Select disabled>
              <Option value="Admin">Admin</Option>
              <Option value="Vendor">Vendor</Option>
            </Select>
          </Form.Item>

          {/* {currentRole === "Vendor" && (
            <>
              <Form.Item name="first_name" label="First Name">
                <Input />
              </Form.Item>
              <Form.Item name="last_name" label="Last Name">
                <Input />
              </Form.Item>
              <Form.Item name="phonenumber" label="Phone Number">
                <Input />
              </Form.Item>
            </>
          )} */}
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input />
          </Form.Item>
          {/* {!editingUser && (
            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true }]}
            >
              <Input type="password" />
            </Form.Item>
          )} */}
          {/* {editingUser && (
            <Form.Item name="status" label="Status">
              <Select>
                <Option value="Active">Active</Option>
                <Option value="Inactive">Inactive</Option>
              </Select>
            </Form.Item>
          )} */}
        </Form>
      </Modal>
    </div>
  );
};

export default StoreManagement;
